// extracted by mini-css-extract-plugin
export var calendarView = "_ms-0";